// @flow
export { default } from './SuccessOrErrorAlert';
export type { Props } from './SuccessOrErrorAlert';



// WEBPACK FOOTER //
// ../react-lib/src/components/notifications/SuccessOrErrorAlert/index.js